export default __webpack_public_path__ + "static/media/type_text.dce923ba.svg";